import { type ReactNode } from 'react';
import { enableNewNavigation } from '@gonfalon/dogfood-flags/dogfood-flags';
import { useSlots } from '@gonfalon/react/useSlots';
import clsx from 'clsx';

import { Breadcrumbs } from '../Breadcrumbs';
import { SidebarToggle, useSidebarContext } from '../Sidebar';

import styles from './LayoutHeader.module.css';

export function LayoutHeader({
  children,
  className,
  layoutHeaderLocationClassName,
  isMaxWidthAndCentered,
}: {
  children?: ReactNode;
  className?: string;
  layoutHeaderLocationClassName?: string;
  isMaxWidthAndCentered?: boolean;
}) {
  const [{ actions }] = useSlots(children, {
    actions: LayoutHeaderActions,
  });

  return (
    <div className={clsx(styles.header, className, { [styles.maxWidthAndCentered]: isMaxWidthAndCentered })}>
      <LayoutHeaderLocation className={layoutHeaderLocationClassName} />
      {actions}
    </div>
  );
}

function LayoutHeaderLocation({ className }: { className?: string }) {
  const sidebar = useSidebarContext();
  const isNewNavigationEnabled = enableNewNavigation();

  return (
    <div className={clsx(styles.location, { [styles.newNavLocation]: isNewNavigationEnabled }, className)}>
      {!isNewNavigationEnabled && (
        <div className={styles.toggle} aria-hidden={sidebar.isVisible ? 'true' : undefined} inert={sidebar.isVisible}>
          <SidebarToggle />
        </div>
      )}
      <Breadcrumbs />
    </div>
  );
}

export function LayoutHeaderActions({ children }: { children: ReactNode }) {
  return <div className={styles.actions}>{children}</div>;
}
